import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import Api from "../Api/Api.json";

const fetchWellnessSummaryData = async (patientId) => {
  const headers = { headers: { "Content-Type": "application/json" } };
  const url = Api.FITNESS_API;
  const requestData = {
    task: "getVitalsTimeseriesSummary",
    patient_id: patientId,
  };
  
  const response = await axios.post(url, requestData, headers);
  console.log("Wellness Summary API Response:", response);
  
  if (!response.data) {
    throw new Error("Network response was not ok");
  }
  
  return response.data;
};

export const useWellnessSummaryData = (patientId) => {
  // Use React Query to fetch and cache data
  return useQuery({
    queryKey: ["wellnessSummaryData", patientId], // Unique key for this query
    queryFn: () => fetchWellnessSummaryData(patientId), // Function to fetch data
    staleTime: 1000 * 60 * 60, // Data is considered fresh for 1 hour
    cacheTime: 1000 * 60 * 60, // Cache data for 1 hour
    enabled: !!patientId, // Only run query if patientId is provided
  });
}; 